import { setLoadingConfigObject, shimmerPlaceholderConfig } from '../../Shimmer/Shimmer.utils';

import styles from './LoadingConfig.Styles';

const filterLoadingConfig = [
  {
    left: [
      'row',
      setLoadingConfigObject('circle', 1, null, styles.firstSectionCircleStyle),
      setLoadingConfigObject('circle', 1, null, styles.firstSectionCircleStyle),
      setLoadingConfigObject('circle', 1, null, styles.firstSectionCircleStyle),
    ],
    style: styles.firstSectionStyle,
  },
];
export { filterLoadingConfig, shimmerPlaceholderConfig };
